import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { exportResearch } from '../../data/vendooExportResearch';

/** The export usability study: setup, what interviews revealed, and each hypothesis with what changed. */
export function ExportResearch() {
  const {
    objective,
    facts,
    interviewInsights,
    hypotheses,
    deckUrl
  } = exportResearch;
  return <div data-id="element-666" data-mp="2ry83w9uzy76a">
      <div className="rounded-2xl bg-surface p-5 md:p-7" data-id="element-667" data-mp="2ryht3v87waax">
        <p className="text-xs font-medium text-rust" data-id="element-668" data-mp="2s018ljm1uhbn">Usability study · Export inventory</p>
        <p className="mt-2 max-w-2xl text-base font-semibold leading-snug text-fg md:text-lg" data-id="element-669" data-mp="2wyw0rc5wpi8f">{objective}</p>
        <dl className="mt-6 grid gap-x-6 gap-y-4 border-t border-line pt-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-670" data-mp="30wjyso2wbr4j">
          {facts.map(f => <div key={f.label} data-id="element-671" data-mp="16l57i2u8ljmo">
              <dt className="text-xs text-fg-faint" data-id="element-672" data-mp="16m6n8km76uaq">{f.label}</dt>
              <dd className="mt-1 text-sm font-medium text-fg" data-id="element-673" data-mp="1bkhwou8kz2sf">{f.value}</dd>
            </div>)}
        </dl>
      </div>

      <div className="mt-10 grid gap-6 md:grid-cols-[200px_1fr] md:gap-10" data-id="element-674" data-mp="dwb48daavajd">
        <h3 className="text-sm font-semibold text-ink" data-id="element-675" data-mp="938hao012zc5">What the interviews showed</h3>
        <ul className="border-t border-line" data-id="element-676" data-mp="51wt8mwsym62">
          {interviewInsights.map(insight => <li key={insight} className="border-b border-line py-3 text-sm leading-relaxed text-fg-muted" data-id="element-677" data-mp="4egsmjktotb">
              {insight}
            </li>)}
        </ul>
      </div>

      <div className="mt-10 grid gap-6 md:grid-cols-[200px_1fr] md:gap-10" data-id="element-678" data-mp="ssk3heu6xnvs">
        <h3 className="text-sm font-semibold text-ink" data-id="element-679" data-mp="sqg151bxwwxm">What testing the prototype changed</h3>
        <ol className="grid gap-3" data-id="element-680" data-mp="nv0mw8a0sz0o">
          {hypotheses.map((h, i) => <Reveal key={h.hypothesis} delay={i * 0.04} data-id="element-681" data-mp="itute88jd7q3" data-mpi={i}>
              <li className="grid gap-4 rounded-2xl border border-line bg-raised p-5 sm:grid-cols-2 sm:gap-6" data-id="element-682" data-mp="38jy7bdsv4t4o">
                <div data-id="element-683" data-mp="33jaeqnozk48c">
                  <p className="text-xs font-medium tabular-nums text-fg-faint" data-id="element-684" data-mp="33iqyrciwbpwy">Hypothesis {i + 1}</p>
                  <p className="mt-1.5 text-sm font-semibold leading-snug text-fg" data-id="element-685" data-mp="3520rg16cpzt3">{h.hypothesis}</p>
                  <p className="mt-2 text-xs leading-relaxed text-fg-muted" data-id="element-686" data-mp="39zsrjih5gs8d">
                    <span className="font-medium text-fg" data-id="element-687" data-mp="2w015qvke67jt">Task: </span>
                    {h.task}
                  </p>
                </div>
                <div className="border-t border-line pt-4 sm:border-l sm:border-t-0 sm:pl-6 sm:pt-0" data-id="element-688" data-mp="311qiqgr6cvaj">
                  <span className={`inline-block rounded-full px-2 py-0.5 text-[11px] font-medium ${h.tone === 'confirmed' ? 'bg-ink-soft text-ink' : 'bg-coral-soft text-rust'}`} data-id="element-689" data-mp="2m96hjlnl4xvq">
                    {h.tone === 'confirmed' ? 'Confirmed' : 'Changed the design'}
                  </span>
                  <p className="mt-2 text-sm leading-relaxed text-fg" data-id="element-690" data-mp="23cndvbvjw26k">{h.result}</p>
                  <p className="mt-1 text-sm leading-relaxed text-fg-muted" data-id="element-691" data-mp="289x3osmuqfux">{h.change}</p>
                </div>
              </li>
            </Reveal>)}
        </ol>
      </div>

      <a href={deckUrl} target="_blank" rel="noreferrer" className="group mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-ink underline decoration-line underline-offset-4 transition-colors duration-150 hover:decoration-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-ink/30 md:ml-[240px]" data-id="element-692" data-mp="1jr50vhm0hy00">
        View the full research deck (PDF)
        <ArrowUpRightIcon className="h-3.5 w-3.5 transition-transform duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden data-id="element-693" data-mp="22o6c3k65suce" />
      </a>
    </div>;
}